module.exports = __webpack_public_path__ + "img/uav-l.50e1c178.png";